export const ERROR_CODE_MESSAGES = {
  SAMPLE_NOT_FOUND: 'Amostra não encontrada. Verifique o código.',
  TARGET_BATCH_NOT_FOUND: 'O lote pra onde você quer mover não existe mais.',
  INVALID_BARCODE: 'Código de barras inválido (mínimo 11 caracteres).',
  IDEMPOTENCY_CONFLICT: 'Essa operação já foi feita. Atualize a tela.',
  AOLWS_TIMEOUT: 'O sistema demorou para responder. Tente novamente.',
  AOLWS_ITEM_FAILED:
    'Não foi possível processar essa amostra. Tente novamente em instantes.',
  AOLWS_DB_FAILED: 'Falha ao registrar movimentação. Tente novamente.',
  BACKPRESSURE: 'Sistema em sobrecarga. Tente novamente em instantes.',
  NO_VALID_HEAD_SAMPLE: 'Nenhuma das amostras selecionadas pode iniciar um novo lote.',
  TARGET_BATCH_CREATION_FAILED: 'Não foi possível criar o novo lote. Tente novamente.',
  TARGET_BATCH_SOURCE_DETACH_FAILED:
    'Não foi possível remover a amostra do lote de origem. Tente novamente.',
  TARGET_BATCH_SOURCE_MISSING:
    'Lote de origem não encontrado. Atualize a lista e tente novamente.',
  TARGET_BATCH_TRANSMISSION_UNAVAILABLE:
    'Não foi possível iniciar a transmissão da amostra. Tente novamente em instantes.',
  TARGET_BATCH_CREATION_EMPTY_IDENTIFIER:
    'O novo lote não foi criado corretamente. Tente novamente.',
  MIXED_ORIGIN: 'Não é possível adicionar amostras LIS em um lote AOL.',
  BATCH_NOT_OPEN: 'O lote não está aberto pra receber amostras.',
  BATCH_IS_PATERNITY: 'Lote é de paternidade e não aceita esta amostra.',
  INCOMPATIBLE_MNEMONIC:
    'Essa amostra é de um tipo diferente das do lote (mnemônico diferente).',
  BATCH_FULL: 'O lote já atingiu a quantidade máxima de amostras.',
  INCOMPATIBLE_PLACE: 'Essa amostra vai pra um local de exame diferente do lote.',
  INCOMPATIBLE_PACKAGING: 'A embalagem dessa amostra é diferente da do lote.',
  INCOMPATIBLE_URGENCY: 'Urgência do lote é incompatível com a amostra.',
  LABORATORY_MISMATCH: 'Essa amostra é de um laboratório diferente do lote.',
  SAME_BATCH: 'Amostra já está neste lote.',
  TARGET_BATCH_COLLECTED: 'Esse lote já foi coletado e não aceita mais amostras.',
  SOURCE_BATCH_COLLECTED:
    'O lote de origem já foi coletado. A amostra não pode ser removida dele.',
  SAMPLE_ALREADY_COLLECTED: 'Amostra já foi coletada e não pode ser incluída no lote.',
  TARGET_BATCH_EXCLUSIVE: 'Este lote não aceita a movimentação da amostra selecionada.',
  BATCH_DAY_EXPIRED: 'O prazo de inclusão desse lote já passou.',
  PATERNITY_SAMPLE: 'Amostras de paternidade não podem entrar nesse loteamento.',
  INVALID_SAMPLE_STATE: 'Essa amostra está em um status que não permite loteamento.',
  'Sample not found!': 'Amostra não encontrada no sistema.',
  'Batch not found!': 'Lote não encontrado.',
  'Sample not found in this batch!': 'Amostra não pertence a este lote.',
  'Source batch identifier does not match sample current batch':
    'Lote de origem não corresponde ao lote atual da amostra.',
  'This batch is not available for sample inclusion':
    'Lote não disponível para receber amostras.',
  'The sample has already been included in a batch.': 'Amostra já está em um lote.',
  'Sem resultado do batch-api para o barcode':
    'Não foi possível obter resposta para a amostra.',
}

export function translateBatchErrorMessage(item) {
  const code = item && item.errorCode ? item.errorCode : null
  const message = item && item.errorMessage ? item.errorMessage : null

  if (code && ERROR_CODE_MESSAGES[code]) return ERROR_CODE_MESSAGES[code]
  if (message && ERROR_CODE_MESSAGES[message]) return ERROR_CODE_MESSAGES[message]

  if (message) {
    if (message.startsWith('SampleTransmit not found'))
      return ERROR_CODE_MESSAGES.SAMPLE_NOT_FOUND
    if (message.startsWith('Target batch not found'))
      return ERROR_CODE_MESSAGES.TARGET_BATCH_NOT_FOUND
    if (message.startsWith('AOLWS_DB_FAILED')) return ERROR_CODE_MESSAGES.AOLWS_DB_FAILED
  }

  return null
}

export function translateBatchErrorFromResponse(errorResponse) {
  if (!errorResponse) return null

  const data =
    errorResponse.data && typeof errorResponse.data === 'object'
      ? errorResponse.data
      : errorResponse

  if (!data || typeof data !== 'object') return null

  const errorCode = data.errorCode || data.code || null
  const errorMessage = data.errorMessage || data.description || data.message || null

  return translateBatchErrorMessage({ errorCode, errorMessage })
}

export function resolveConflictToastTitle(errorResponse) {
  if (!errorResponse) return 'Amostra já loteada'

  const data =
    errorResponse.data && typeof errorResponse.data === 'object'
      ? errorResponse.data
      : errorResponse

  if (!data || typeof data !== 'object') return 'Amostra já loteada'

  const code = data.errorCode || data.code || null

  if (code === 'IDEMPOTENCY_CONFLICT') return 'Atenção'

  return 'Amostra já loteada'
}
